import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from '../features/userSlice';
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  Typography,
  Snackbar,
  Alert,
  InputLabel,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Link,
  Divider,
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useNavigate } from 'react-router-dom';


const RegistrationForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.user);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    role: '4',
    contact_no: '',
    name: '',
    displayName: 'original', // Add displayName to state
  });

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(registerUser(formData)).then((res) => {
            if (!res.error) {
                setSnackbar({
                    open: true,
                    message: 'Registration successful! Please log in.',
                    severity: 'success',
                });
                setFormData({
                    username: '',
                    email: '',
                    password: '',
                    role: '4',
                    contact_no: '',
                    name: '',
          displayName: 'original',
                });
          navigate('/login');
            } else {
                setSnackbar({
                    open: true,
                    message: 'Registration failed. Please try again.',
                    severity: 'error',
                });
            }
        });
    };

  const handleGoogleLogin = () => {
    // Add Google Login integration logic here
    console.log('Google Login clicked');
  };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        
        <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        maxWidth: 500,
        backgroundColor: '#f9f9f9',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        padding: 4,
        borderRadius: 3,
        margin: 'auto',
        mt: 5,
      }}
    >
      <Typography
        variant="h4"
        color="primary"
        textAlign="center"
        sx={{ fontWeight: 'bold', mb: 2 }}
      >
        Create Your Account
      </Typography>

      {/* <Button
        onClick={handleGoogleLogin}
        variant="outlined"
        startIcon={<GoogleIcon />}
        fullWidth
        sx={{
          textTransform: 'none',
          fontSize: '1rem',
          color: '#4285F4',
          borderColor: '#4285F4',
          '&:hover': { backgroundColor: '#e8f0fe' },
        }}
      >
        Sign up with Google
      </Button>

      <Divider sx={{ my: 2 }}>OR</Divider> */}

      <TextField
        label="Full Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        fullWidth
        required
        variant="outlined"
      />
      <TextField
        label="Contact Number"
        name="contact_no"
        value={formData.contact_no}
        onChange={handleChange}
        fullWidth
        required
        variant="outlined"
      />
      <TextField
        label="Email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        fullWidth
        required
        variant="outlined"
      />
      <TextField
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        fullWidth
        required
        variant="outlined"
      />
      
      {/* <FormControl fullWidth required>
        <InputLabel>Role</InputLabel>
        <Select
          name="role"
          value={formData.role}
          onChange={handleChange}
          variant="outlined"
        >
          <MenuItem value="4">Select Role</MenuItem>
          <MenuItem value="4">Vendor</MenuItem>
        </Select>
      </FormControl> */}

      {/* <FormControl fullWidth required>
        <InputLabel>Role</InputLabel>
        <Select
          name="role"
          value={formData.role}
          onChange={handleChange}
          variant="outlined"
        >
          <MenuItem value="2">Patient</MenuItem>
          <MenuItem value="3">Provider</MenuItem>
         
          <MenuItem value="4">Vendor</MenuItem>
        </Select>
      </FormControl> */}

      {/* {formData.role === '2' && (
        <FormControl component="fieldset" sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
           Anonymous Name
          </Typography>
          <TextField
            label="Anonymous"
            name="petname"
            value={formData.petname}
            onChange={handleChange}
            fullWidth
            required
            variant="outlined"
          />
        </FormControl>
      )} */}

      <Button
        variant="contained"
        color="primary"
        type="submit"
        fullWidth
        sx={{
          padding: 1,
          fontSize: "1rem",
          fontWeight: "bold",
        }}
        disabled={loading}
      >
        {loading ? "Submitting..." : "Register"}
      </Button>

      <Typography variant="body2" textAlign="center" sx={{ mt: 2 }}>
        Already have an account?{' '}
        <Link
          href="/login"
          underline="hover"
          color="primary"
          onClick={(e) => {
            e.preventDefault();
            navigate('/login'); // Navigate to login page
          }}
        >
          Log in here
        </Link>
      </Typography>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RegistrationForm;
